<template>
  <div>
    <div class="my-8 p-8 bg-white rounded text-gray-800">
      <!-- Page 1 -->
      <div style="break-after: page;">
        <p class="font-bold text-left text-lg uppercase">Notice To Trustee</p>
        <p class="py-3 font-bold text-left uppercase">{{ fundName }}</p>
        <p class="py-2 font-bold text-left uppercase">
          Benefit Payment Instructions for the Financial Year: {{ finYear }}
        </p>
        <p class="mt-4" v-if="ratify === 'FULLYPROSPECTIVE'">
          To the extent permitted by superannuation law,
          {{ numMembers === 1 ? 'I' : 'we' }} hereby request that when
          {{ numMembers === 1 ? 'I' : 'we' }} take benefit payments from the
          Fund during the {{ finYear }} financial year, they are
          drawn from the various member accounts and classified in the priority order shown in
          the attached schedule.
        </p>
        <p class="mt-4" v-else-if="ratify === 'FULLYRRATIFYING'">
          As previously agreed, to the extent permitted by superannuation law,
          {{ numMembers === 1 ? 'I' : 'we' }} hereby request that when
          {{ numMembers === 1 ? 'I' : 'we' }} take benefit payments from the
          Fund during the {{ finYear }} financial year, they are
          drawn from the various member accounts and classified in the priority order shown in
          the attached schedule.
        </p>
        <p class="mt-4" v-else>
          To the extent permitted by superannuation law,
          {{ numMembers === 1 ? 'I' : 'we' }} hereby request that when
          {{ numMembers === 1 ? 'I' : 'we' }} take benefit payments from the
          Fund during the remainder of the {{ finYear }} financial year, they are
          drawn from the various member accounts and classified in the priority order shown in
          the attached schedule.
        </p>
        <p class="mt-4">
          If it is not possible to follow these instructions for any particular
          payment, the trustee should seek specific instruction for that
          payment. These instructions may be superseded by individual payment
          instructions at any time.
        </p>
        <div style="break-inside: avoid;">
          <p class="mt-2">
            Yours faithfully,
          </p>
          <div class="px-0 mt-12">
            <table class="table-auto w-full">
              <tbody>
                <tr class="w-full">
                  <template v-for="(member, idx) in members">
                    <td :key="`${idx}-add`" v-if="idx === 1"></td>
                    <td :key="idx" class="w-2/12 py-2">
                      __________________________________
                    </td>
                  </template>
                </tr>

                <tr class="w-full">
                  <template v-for="(member, idx) in members">
                    <td :key="`${idx}-add`" v-if="idx === 1"></td>
                    <td :key="idx" class="w-2/12 py-2">
                      {{ member.name }}
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="px-0 mt-4">
            <table class="table-auto w-full">
              <tbody>
                <tr class="mt-12">
                  <td class="py-2">
                    __________________________________
                  </td>
                </tr>
                <tr>
                  <td class="mt-2 text-left w-2/12">Date</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- Page 2 -->
      <div style="break-after: page;">
        <schedule></schedule>
      </div>
      <!-- Page 3 -->
      <div style="break-after: page;">
        <minutes></minutes>
      </div>
      <!-- Page 4 -->
      <div style="break-after: page;">
        <schedule></schedule>
      </div>
      <!-- Page 5 -->
      <div style="break-after: page;">
        <notice></notice>
      </div>
      <!-- Page 6 -->
      <div style="break-after: page;">
        <schedule></schedule>
      </div>
    </div>
  </div>
</template>

<script>
import { pensionInstructionMixin } from '@/app/mixins/toolkit/pension-instructions/instruction';
import minutes from './minutes.vue';
import notice from './notice.vue';
import schedule from './schedule.vue';

export default {
  name: 'pension-payment-instruction',
  mixins: [pensionInstructionMixin],
  components: { minutes, notice, schedule },
  computed: {
    rules() {
      const { rules } = this.getItem;
      return rules;
    },
  },
  methods: {
    isComputedRule(rule) {
      return (typeof rule !== 'string');
    },
    processRule(rule) {
      if (this.isComputedRule(rule)) {
        return this.processedPDF(rule);
      }
      return rule;
    },
    accounts(rule) {
      const output = [];

      rule.accounts.ruleAccounts.forEach((account) => {
        let row = '';
        if (rule.extra.type === 'percentage') {
          row = `<span class="font-bold">${account.value}%</span> - `;
        }
        row += `${account.member.name} / ${account.label} / ${account.identifier} / ${(account.taxFree * 100)}% tax free`;
        output.push(row);
      });
      return output;
    },
  },
};
</script>
